const apiClient = {
  loadItems() {
    return Promise.resolve(JSON.parse(localStorage.getItem('items') || '[]'));
  },

  saveItems(items) {
    return new Promise((resolve) => {
      localStorage.setItem('items', JSON.stringify(items));
      resolve({ success: true });
    });
  }
};

export default apiClient;
